<template>
  <container title='出租率分析' :loading='loading' :nodata='nodata' style='padding-bottom: 0;height: 266px;'>
    <div id='rentalRateAnalysis' style='height: 225px;'>

    </div>
  </container>
</template>

<script>
  import container from "../container";
  import {getManagementRentRate} from "../../../../../api/bigData";

  export default {
    name: "rentalRateAnalysis",
    components: {
      container,
    },
    data() {
      return {
        myChart: null,
        initData: [],
        datas: [],
        loading: false,
        nodata: false,
      }
    },
    methods: {
      initEcharts() {
        var echarts = require('echarts');
        var myChart = echarts.init(document.getElementById('rentalRateAnalysis'));
        this.myChart = myChart
        let data = this.initData
        let arrName = getArrayValue(data, "name");
        let arrValue = getArrayValue(data, "value");
        let sumValue = 100;
        let objData = array2obj(data, "name");
        let optionData = getData(data)

        function getArrayValue(array, key) {
          var key = key || "value";
          var res = [];
          if (array) {
            array.forEach(function (t) {
              res.push(t[key]);
            });
          }
          return res;
        }

        function array2obj(array, key) {
          var resObj = {};
          for (var i = 0; i < array.length; i++) {
            resObj[array[i][key]] = array[i];
          }
          return resObj;
        }

        function getData(data) {
          var res = {
            series: [{
              name: "大环",
              type: 'gauge',
              splitNumber: 15,
              radius: '85%',
              center: ['50%', '50%'],
              startAngle: 90,
              endAngle: -269.9999,
              axisLine: {
                show: false,
                lineStyle: {
                  color: [
                    [1, '#1f59a7']
                  ]
                }
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: true,
                length: 10,
                lineStyle: {
                  color: 'auto',
                  width: 2
                }
              },
              axisLabel: {
                show: false
              },
              detail: {
                show: false
              }
            },
              {
                name: '小环',
                type: 'gauge',
                splitNumber: 15,
                radius: '78%',
                center: ['50%', '50%'],
                startAngle: 90,
                endAngle: -269.9999,
                axisLine: {
                  show: false
                },
                axisTick: {
                  show: true,
                  lineStyle: {
                    color: '#1f59a7',
                    width: 2
                  },
                  length: 10,
                  splitNumber: 5
                },
                splitLine: {
                  show: false
                },
                axisLabel: {
                  show: false
                },
                detail: {
                  show: false
                }
              },
            ],
            yAxis: []
          };
          for (let i = 0; i < data.length; i++) {
            res.series.push({
              type: 'pie',
              clockWise: true,
              z: 2,
              hoverAnimation: false,
              radius: [73 - i * 15 + '%', 68 - i * 15 + '%'],
              center: ["50%", "50%"],
              label: {
                show: false,
                formatter: '{d}%',
                color: 'RGB(246,175,101)',
                fontSize: 25,
                position: 'inside'
              },
              labelLine: {
                show: false
              },
              data: [{
                value: data[i].value,
                name: data[i].name
              }, {
                value: sumValue - data[i].value,
                name: '',
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0
                },
                tooltip: {
                  show: false
                },
                label: {
                  show: false
                },
                hoverAnimation: false
              }]
            });
            res.series.push({
              name: '背景线',
              type: 'pie',
              silent: true,
              z: 1,
              clockWise: true,
              hoverAnimation: false,
              radius: [71 - i * 15 + '%', 69 - i * 15 + '%'],
              center: ["50%", "50%"],
              label: {
                show: false
              },
              itemStyle: {
                label: {
                  show: false,
                },
                labelLine: {
                  show: false
                },
                borderWidth: 1,
              },
              data: [{
                value: 100,
                itemStyle: {
                  color: "RGB(12,64,128)",
                  borderWidth: 0
                },
                tooltip: {
                  show: false
                },
                hoverAnimation: false
              }]
            });
            res.yAxis.push(data[i].name);
          }
          return res;
        }

        let option = {
          tooltip: {
            formatter: '{b0}: {c0}%'
          },
          color: [{
            type: 'linear',
            x: 0,
            y: 0,
            x2: 1,
            y2: 1,
            colorStops: [{
              offset: 0,
              color: 'rgba(10,31,95,1)'
            }, {
              offset: 1,
              color: '#2CE1FA'
            }],
            global: false
          }],
          grid: {
            top: '16%',
            bottom: '54%',
            left: "50%",
            containLabel: false
          },
          yAxis: [{
            type: 'category',
            inverse: true,
            z: 3,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              inside: false,
              textStyle: {
                color: "RGB(78,184,252)",
                fontSize: 14,
              },
              show: false
            },
            data: optionData.yAxis
          }],
          xAxis: [{
            show: false
          }],
          series: optionData.series
        };

        this.myChart.setOption(option)
        this.myChart.on('click', (params) => {
          let companyName = params.name
          let companyId = ''
          for (let i = 0; i < this.initData.length; i++) {
            if (companyName == this.initData[i].name) {
              companyId = this.initData[i].companyId
              break
            }
          }
          let query = {companyId, companyName}
          this.$router.push({path: '/assetLeasing', query: query})
          query
        })
      },

      init() {
        this.loading = true
        getManagementRentRate({}).then(res => {
          let data = res.data
          if (data.code === '000') {
            let initData = data.content
            for (let i = 0; i < initData.length; i++) {
              initData[i].name = initData[i].companyName
              initData[i].value = initData[i].rentRate * 100
            }
            this.initData = initData
            this.loading = false
            this.$nextTick(function () {
              this.initEcharts()
            })

          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading = false
          this.nodata = !this.initData.length
        })
      },
    },
    created() {
      this.init()

    },
  }
</script>

<style scoped lang="scss">
  .rentalRateAnalysis {

  }
</style>
